import { CLEAR_MESSAGE ,SET_MESSAGE } from "../actions/types";

const initialState = {
  msg: "",
  status: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_MESSAGE:
      return {
        msg: "",
        status: null,
      };
    case SET_MESSAGE:
      return {
        msg: action.payload.msg,
        status: action.payload.status,
      };
    default:
      return state;
  }
}
